var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpWhiteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.41176H14M6 8.94118H12M7 13.3529H4C3.20435 13.3529 2.44129 13.0741 1.87868 12.5776C1.31607 12.0812 1 11.4079 1 10.7059V3.64706C1 2.94502 1.31607 2.27173 1.87868 1.77531C2.44129 1.27889 3.20435 1 4 1H16C16.7956 1 17.5587 1.27889 18.1213 1.77531C18.6839 2.27173 19 2.94502 19 3.64706V10.7059C19 11.4079 18.6839 12.0812 18.1213 12.5776C17.5587 13.0741 16.7956 13.3529 16 13.3529H13L10 16L7 13.3529Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpWhiteIcon);
export default __webpack_public_path__ + "static/media/helpWhiteIcon.f8317b42f2dac6588e2e4c9ddf8f72af.svg";
export { ForwardRef as ReactComponent };